import { NgModule } from '@angular/core';
import { BackdropComponent } from 'components/backdrop/backdrop.component';

@NgModule({
    imports: [],
    declarations: [BackdropComponent],
    exports: [BackdropComponent]
})
export class BackdropModule {}
